import { BoObject } from '../../public_api';
import { QueovalBase } from '../global';


export class ModelEmailModel extends QueovalBase {
  /**
   * Modèle de mail sélectionné
   */
  public ModelMailSelected: ModelMail;
  /**
   * Liste des modèle de mail
   */
  public ListModelsMail: ModelMail[];
  /**
   * Liste de BO
   */
  public ListBoObject: BoObject[];

  public ListBo: Array<string>;

  public GroupeModelMail: string;
}



export class ModelMail {
  public CkeditorVersion: string;
  public To: Array<string>;
  /**
   * Ident
   */
  public Ident: string;
  /**
   * Code du modèle
   */
  public CodeModel: string;
  /**
   * Infos du modèles
   */
  public InfoModel: string;
  /**
   * Contenu du mail
   */
  public ContentMail: string;
  /**
   * Mail de l'expéditeur
   */
  public SenderMail: string;
  /**
   * Objet
   */
  public Object: string;
  /**
   * CC
   */
  public CC: Array<string>;
  /**
   * CCI
   */
  public CCI: Array<string>;
  /**
   * Si c'est le modèle par défaut
   */
  public IsDefault: boolean;

  constructor() {
    this.CodeModel = '';
    this.ContentMail = '';
    this.To = [];
    this.CC = [];
    this.CCI = [];
  }
}
